import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-right",
  "use": "svg_arrow-right-usage",
  "viewBox": "0 0 9 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14\" id=\"svg_arrow-right\"><path d=\"m1 13 6-6-6-6\" stroke=\"#fff\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol